import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/app/[locale]/page.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/components/sections/ClientShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8df0e6997faac0c/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/components/sections/DeviceShowcase.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/components/sections/EnhancedTestimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8df0e6997faac0c/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IndustriesCarousel"] */ "/tmp/8df0e6997faac0c/components/sections/IndustriesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/components/sections/KeyTakeawaysSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/components/sections/SolutionsDeepDive.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/components/ui/Button.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8df0e6997faac0c/components/ui/LazyVideo.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/components/sections/TechPartnersSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
